module.exports = require("node-notifier");


//////////////////
// WEBPACK FOOTER
// external "node-notifier"
// module id = 169
// module chunks = 0